module.exports = __webpack_public_path__ + "img/l-hd.67a657a6.webp";